import FJActionConstant from "../../constant/FJActionConstant";
import FJTimelineStore from "fj-timeline";

const initState = {
  bricks: {
    mainLayer: [],
    subLayer: [],
    subAudioLayer: [],
  },
  transitions: [],
  graphViewData: {},
  selectedId: -1,
  duration: 0, // 总时长 在end的时候才去改变
  realDuration: 0, // 总时长 在change的时候就开始改变
  currentTime: 0, // 播放进度的对应时间
  previewTime: 0, // 预览的对应时间;lafjlasjgfkldashgklhfaskl
  timeLineHeightRadio: 0.34, // 时间轴区域占 body高度（除去header）的比列
  adsorptionLineHorizontalValues: [], // []]时不渲染吸附线
  isDragging: false, // 是否拖动资源到时间轴拖动
  mainLayerVolume: 1,
  couldSplit: false, // 是否可以裁剪
  unitConversion: FJTimelineStore.getUnitConversion(),
  isCoverEle: false, // 是否覆盖某个元素,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_TIMELINE_SELECTION:
      return {
        ...state,
        selectedId: action.id,
      };
    case FJActionConstant.UPDATE_ALL_TIMELINE_BRICK: {
      let {mainLayer, subLayer, subAudioLayer, transitions} = action.data;
      return {
        ...state,
        bricks: {mainLayer, subLayer, subAudioLayer},
        transitions: transitions,
      };
    }
    case FJActionConstant.UPDATE_ALL_TIMELINE_GRAPH:
      return  {
        ...state,
        graphViewData: {...action.data},
      };
    case FJActionConstant.UPDATE_DURATION:
      return {
        ...state,
        duration: action.duration,
      };
    case FJActionConstant.SET_DRAGGING_STATE:
      return {
        ...state,
        isDragging: action.data
      };
    case FJActionConstant.SET_VIDEO_CURRENT_TIME:
      return {
        ...state,
        currentTime: action.data
      };
    case FJActionConstant.SET_VIDEO_PREVIEW_TIME:
      return {
        ...state,
        previewTime: action.data
      };
    case FJActionConstant.UPDATE_REAL_DURATION:
      return {
        ...state,
        realDuration: action.data
      };
    case FJActionConstant.SET_TIME_LINE_HEIGHT_RADIO:
      return {
        ...state,
        timeLineHeightRadio: action.data
      };
    case FJActionConstant.SET_TIMELINE_ADSORPTION:
      return {
        ...state,
        adsorptionLineHorizontalValues: action.value,
      }
    case FJActionConstant.SET_MAIN_LAYER_VOLUME:
      return {
        ...state,
        mainLayerVolume: action.volume,
      }
    case FJActionConstant.UPDATE_SPLIT_STATUS: {
      return {
        ...state,
        couldSplit: action.couldSplit,
      }
    }
    case FJActionConstant.UPDATE_UNIT_CONVERSION: {
      return {
        ...state,
        unitConversion: action.data
      }
    }
    case FJActionConstant.UPDATE_COVER_ELE_STATUS: {
      return {
        ...state,
        isCoverEle: action.couldStatus
      }
    }
    default:
      return state;
  }
}
